import { MULTI_SELECT_ACTIONS } from './multi-select';
import { RELATIONSHIP_ACTIONS } from './relationship';
export const ACTION = ({
  ADD_ANNOTATION: 'ADD_ANNOTATION',
  BULK_ADD_ANNOTATIONS: 'BULK_ADD_ANNOTATIONS',
  UPDATE_ANNOTATION: 'UPDATE_ANNOTATION',
  DELETE_ANNOTATION: 'DELETE_ANNOTATION',
  DELETE_ANNOTATIONS: 'DELETE_ANNOTATIONS',
  ZOOM: 'ZOOM',
  UNDO: 'UNDO',
  SELECT_SUB_TOOL: 'SELECT_SUB_TOOL',
  CREATE_VIDEO_FRAMES: 'CREATE_VIDEO_FRAMES',
  UPDATE_ALL_ANNOTATION_FRAME_SPAN: 'UPDATE_ALL_ANNOTATION_FRAME_SPAN',
  DELETE_ANNOTATION_FRAME_SPAN: 'DELETE_ANNOTATION_FRAME_SPAN',
  IMPORT_ANNOTATIONS: 'IMPORT_ANNOTATIONS',
  TOGGLE_ANNOTATION_RELATIONSHIP_VIEW: 'TOGGLE_ANNOTATION_RELATIONSHIP_VIEW',
  ...RELATIONSHIP_ACTIONS,
  ...MULTI_SELECT_ACTIONS
} as const);
export const PROPAGATION_METHOD = ({
  TRACKING: 'TRACKING',
  INTERPOLATION: 'INTERPOLATION'
} as const);